/*
 * @Author: liuYingBing
 * @Date: 2024-09-05 16:47:19
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-11-29 18:42:05
 * @FilePath: /fushigi/src/hooks/useCertificateModal/index.ts
 * @Description:
 */
import { message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { createVNode } from 'vue'
import { PATH } from '@/enum'
import router from '@/router'
import { usePayUrl, useUserStore } from '@/store'

/**
 * @description: 跳转认证弹框
 * @param {boolean} isNewPage 是否跳转新页面
 * @return {*}
 */
export default function useCertificateModal() {
  // 打开弹框
  const showCertificate = (isNewPage?: boolean) => {
    const userStore = useUserStore()

    Modal.confirm({
      title: '提示',
      centered: true,
      icon: createVNode(ExclamationCircleOutlined),
      content: '请先完成个人/企业实名认证',
      okText: '前往认证',
      cancelText: '已认证',
      onOk() {
        // 跳转认证模块
        return new Promise((resolve, reject) => {
          const url = JSON.parse(JSON.stringify(router.currentRoute.value.fullPath || ''))
          // 记录回跳地址
          usePayUrl().setUrl(url)
          if (isNewPage) {
            // 跳转新页面
            const { href } = router.resolve({
              path: PATH.ACCOUNT, // 跳转的页面路由
              query: {
                // 要传的参数
                tab: 'checkInfo',
              },
            })
            window.open(href, '_blank')
            reject()
          } else {
            resolve(router.push(`${PATH.ACCOUNT}?tab=checkInfo`))
          }
        })
      },
      async onCancel() {
        return new Promise(async (resolve, reject) => {
          await userStore.getUserBasicInfo()
          // 更新用户信息
          // 判断是否已认证
          if (userStore.certified) {
            // 如果已认证，关闭模态框
            window.location.reload()
            resolve(true)
          } else {
            // 如果未认证，不关闭模态框
            message.error('您尚未完成实名认证')
            reject()
          }
        })
      },
    })
  }
  return { showCertificate }
}
